export default __webpack_public_path__ + "static/media/phone-icon.cc9c678b.svg";